import React from 'react';
import PublicThemeRenderer from '../public/PublicThemeRenderer';

const LivePreviewContainer = ({ business, categories = [], products = [] }) => {
  if (!business) return null;

  return (
    <div className="preview-sticky-frame">
      <div
        style={{
          background: '#1E293B',
          padding: '8px 16px',
          borderRadius: '30px 30px 0 0',
          color: '#94A3B8',
          fontSize: '0.75rem',
          fontWeight: '700',
          letterSpacing: '1px',
          textAlign: 'center',
          textTransform: 'uppercase',
          borderBottom: '1px solid rgba(255,255,255,0.08)'
        }}
      >
        Live Phone Preview
      </div>
      <div className="preview-screen">
        <PublicThemeRenderer
          business={business}
          categories={categories}
          products={products}
          isPreview={true}
        />
      </div>
    </div>
  );
};

export default LivePreviewContainer;
